<template>
  <v-breadcrumbs :items="breadcrumbs" >
    <template slot="item" slot-scope="props">
      <v-breadcrumbs-item
        :to="props.item.to"
        :disabled="props.item.disabled"
        exact
      >{{ (!props.item.itemName.length ? $vuetify.t('$vuetify.Breadcrumb.'+ props.item.name) : props.item.itemName).toUpperCase() }}</v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: "Breadcrumb",
  methods: {
    routeTo(pRouteTo) {
      if (pRouteTo.routeName) {
        this.$router.push({
          name: pRouteTo.routeName,
          params: pRouteTo.routeParams
        });
      }
    }
  },
  computed: {
    breadcrumbs() {
      return this.$store.getters.breadcrumbs;
    }
  }
};
</script>